import "@/App.css";
import { useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import SchengenCalculator from "@/pages/SchengenCalculator";
import Login from "@/pages/Login";
import ImprintPage from "@/pages/Imprint";
import PrivacyPage from "@/pages/Privacy";
import CookieConsent from "@/components/CookieConsent";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { I18nProvider, useT } from "@/lib/i18n";
import { track } from "@/lib/analytics";

function AuthedShell() {
  const { status } = useAuth();
  const { t } = useT();
  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-400 text-sm font-mono-terminal">
          {t("trips.loading")}
        </div>
      </div>
    );
  }
  if (status === "authed") return <SchengenCalculator />;
  return <Login />;
}

// Fire a GA page_view event on every route change. When analytics is not
// consented, `track` becomes a no-op so this is safe.
function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    track("page_view", {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <div className="App dark min-h-screen bg-background text-foreground">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <RouteTracker />
            <Routes>
              <Route path="/impressum" element={<ImprintPage />} />
              <Route path="/imprint" element={<ImprintPage />} />
              <Route path="/datenschutz" element={<PrivacyPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="*" element={<AuthedShell />} />
            </Routes>
          </BrowserRouter>
          <CookieConsent />
        </AuthProvider>
      </I18nProvider>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
